define('app/models/subscriber',['app/setup'], function(takhfifan) {
  takhfifan.Subscriber = Backbone.Model.extend({

    validation: {
      email: [{
          required: true,
          msg: i18n.t('email_missing')
        }, {
          pattern: 'email',
          msg: i18n.t('email_invalid')
      }],
      phone: [{
          required: true,
          msg: i18n.t('phone_missing')
        }, {
          pattern: /^0[0-9]{10}$/,
          msg: i18n.t('phone_invalid')
      }],
      city: {
        required: true,
        msg: i18n.t('choose_city')
      }
    },
    
    filterPath : function(){
      var filter = /^\//i ;
      var filteredPath = window.location.pathname.replace(filter,'');
      return filteredPath;
    },

    submit: function(url) {
      if (typeof url === 'undefined' || url === null) {
        return false;
      }
      var _this = this;
      _this.trigger('newsletter:loading');
      $.post(url, {
        email: this.get('email'),
        phone: this.get('phone'),
        page_name: _this.filterPath(),
        city: this.get('city')
      },
      function(response) {
        if (response['result'] === 0) {
          _this.trigger('submit:success');
          takhfifan.eventHub.trigger('newsletter:subscribe');
          takhfifan.eventHub.trigger('session:shouldUpdate');
        } else {
          _this.trigger('submit:invalid', [_this.validation.email[1].msg]);
        }
      });
    }
  });

});

